import Bestellung from "@/entities/common/bestellung"
import { AbholzeitType, Terminart } from "@/entities/common/enums"
import BPBeginnenRequest from "@/entities/common/pending/bp_beginnen_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import BestellungPending from "@/entities/common/bestellung_pending"
import BestellungFilialeRequest from "@/entities/common/request/bestellung_filiale_request"
import vuexStore from "@/store"
import BestellungList from "@/entities/common/lists/bestellung_list"

export default class AbholungStartenLogic extends BaseLogic {
  bestellungen: Bestellung[] = []

  bestellungStarten() {
    var request = new BPBeginnenRequest()
    request.filialeId = this.filiale.filialeId
    request.terminart = Terminart.ABHOLUNG
    request.direktabholung = true
    request.identifier = store.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnen,
      request
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.ABHOLUNG
        this.mainLogic.bestellungPending.abholung.abholzeitType =
          AbholzeitType.BALDEST
        this.mainLogic.bestellungPending.abholung.direktabholung = true

        this.mainLogic.neueBestellung = true
        router.push({ name: RouteNames.NEU.VERZEHRART })
      }
    })
  }

  init() {
    var request = new BestellungFilialeRequest()
    request.identifierId = vuexStore.state.user.identifier
    request.filialeId = this.mainLogic.filiale.filialeId

    Poster.postUser<RemoteResult<BestellungList>>(
      RestPaths.bestellungKundeFilialeAktuell,
      request
    ).then((response) => {
      if (response.data.success) {
        this.bestellungen = response.data.payload.list
      }
    })
  }
}
